import Api from "./api.service";

export default {
  updateUser(object) {
    return Api().patch(`user/accountDelete/${object.id}`, object.object);
  }
};
